import React from 'react';
import {useHeader, useSubheader} from '../../_metronic/layout';
import {useIntl} from 'react-intl';
import BankStatements from '../modules/BankStatements/BankStatementsPage';

export function BankStatementsPage() {
  const header = useHeader();
  header.setTitle(useIntl().formatMessage({
    id: 'bankStatements-page-title',
    defaultMessage: 'Bank Statements'
  }));
  const subheader = useSubheader();
  subheader.setCustomClassName('subheader-custom-height');
  subheader.setDisplaySubheader(false);

  return <BankStatements/>;
}
